import { Link } from 'react-router-dom';
import BtnArrow from '../../../btnArrow/btnArrow';
import './article_4.scss';
import BI from './assets/bi.png';

export default function Article_4() {

    window.scrollTo(0, 0);

    return (
        <div className="article_4">
            <img src={BI} alt="header" />
            <div className="content">
                <div className="row">
                    <div className="article_4_blue">
                        <h1>
                            Как правильно вкладывать деньги в ценные бумаги
                        </h1>

                        <Link to="/peculiarities_traiding">
                            <BtnArrow txt="ОБУЧЕНИЕ" />
                        </Link>
                    </div>
                    <div className="article_4_black">
                        <p>
                            Из-за снижения банковских ставок вкладчики начали гораздо активнее выходить на рынок ценных бумаг. Так, число клиентов на брокерском обслуживании и в доверительном управлении выросло за январь-март, соответственно, на 18% и 14% (до 5 млн и 390 тысяч лиц). При этом основную часть новых клиентов к торговле на бирже привлекают сами банки.
                        </p>
                    </div>
                </div>

                <div className="row">
                    <div className="article_4_black">
                        <h2>
                            ГЛАВНЫЕ ПРИНЦИПЫ ГРАМОТНЫХ ВЛОЖЕНИЙ
                        </h2>
                        <h5>
                            1. Не инвестировать последние сбережения
                        </h5>
                        <p>
                            <span>
                                Сначала следует убедиться в наличии минимального «личного резервного фонда» в размере трех-шести месячных доходов. В этом году ситуация с пандемией отлично показала, как важно домохозяйствам иметь подобный резерв, чтобы в ситуации форс-мажора сохранять возможность поддерживать привычный уровень жизни, обслуживать обязательные платежи и так далее.
                            </span>
                        </p>
                    </div>

                    <div className="article_4_blue">
                        <div className="row">
                            <div className="article_4_blue_column"></div>
                            <div className="article_4_blue_content">
                                <p>
                                    Средняя максимальная ставка по вкладам в топ-10 банках опустилась до очередного исторического и заодно психологического барьера, следует из данных Банка России. По итогам второй декады июня она составила
                                </p>
                                <h3>
                                    4,99%
                                </h3>
                            </div>
                        </div>
                    </div>

                    <h5>
                        2. Остерегаться решений под влиянием эмоций или ажиотажа
                    </h5>
                    <p>
                        <span>
                            Деньги любят спокойствие и холодный расчет. Например, если вы купили акции, а они на следующий день просели, но при этом ваш горизонт больше года, продавать их совершенно нецелесообразно.
                        </span>
                    </p>
                    <h5>
                        3. Отталкиваться от финансовой цели
                    </h5>
                    <p>
                        <span>
                            В части инвестиций подобной личной стратегией может служить персональный финансовый план. Сумма вложений, желательный срок достижения цели, инвестиционный профиль и другие параметры, отраженные в нем, позволяют подобрать такой состав инструментов, который будет в прогнозируемом режиме приближать достижение цели инвестора, его состав при необходимости будет регулярно корректироваться. Если, к примеру, говорить про «длинные» инвестиции от трех лет, то текущие цены на многие акции крупнейших российских компаний представляются интересными для покупки «в долгую».
                        </span>
                    </p>
                    <h5>
                        4. Изучать спектр возможностей для частных инвесторов
                    </h5>
                    <p>
                        <span>
                            Как правило, акции в частных портфелях балансируются более консервативными инструментами, к которым относятся государственные облигации, надежные корпоративные бонды, золото. Кроме того, в последнее время получили широкое распространение готовые решения для частных инвесторов, в том числе начинающих — структурные продукты с полной защитой капитала. Даже с учетом консервативной защиты они способны принести результат, заметно более интересный в сравнении со средними ставками по вкладам. По сути структурный продукт с полной защитой капитала — это способ приобщиться к фондовому рынку для новичка, вложившись, к примеру, в акции, но при этом полностью обезопасить себя от риска уйти в минус.
                        </span>
                    </p>
                    <h5>
                        5. Пользоваться налоговыми льготами
                    </h5>
                    <p>
                        <span>
                            Покупка ценных бумаг, инвестиционных продуктов может оказаться более выгодной за счет использования налоговых стимулов для частных инвесторов. В частности, российские акции и другие эмитированные в России финансовые инструменты можно покупать на ИИС (индивидуальный инвестиционный счет) и получать при соблюдении несложных условий налоговый вычет в объеме до 52 тысяч рублей в год дополнительно к результату инвестиций.
                        </span>
                    </p>
                </div>
            </div>
        </div>
    )
}